module.exports = __webpack_public_path__ + "img/jz1.4e8acfe3.png";